import React from 'react';
import { compose } from 'redux';
import cloneDeep from 'lodash/cloneDeep';
import orderBy from 'lodash/orderBy';


import { Col } from 'react-bootstrap';


import * as Table from 'reactabular-table';
import * as search from 'searchtabular';
import * as sort from 'sortabular';
import * as resolve from 'table-resolver';

import {
  Paginator, PrimaryControls, paginate
} from '../tableHelpers';

import _ from 'underscore'

import { translate } from 'react-i18next';

@translate(['common'])
export default class SyncProductsTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rows: this.props.users,
      searchColumn: 'all',
      query: {},
      sortingColumns: null,
      columns: this.getColumns(),
      pagination: {
        page: 1,
        perPage: 5
      }
    };

    this.onRow = this.onRow.bind(this);
    this.onRowSelected = this.onRowSelected.bind(this);
    this.onColumnChange = this.onColumnChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onPerPage = this.onPerPage.bind(this);
    this.onToggleColumn = this.onToggleColumn.bind(this);
    this.getColumns = this.getColumns.bind(this);
  }


  componentDidUpdate(prevProps) {
    if (prevProps.users !== this.props.users) {
      this.setState({ rows: this.props.users })
    }
  }


  getColumns() {

    var self = this;

    const {t} = self.props

    const sortable = sort.sort({
      getSortingColumns: () => this.state.sortingColumns || [],
      onSort: selectedColumn => {
        this.setState({
          sortingColumns: sort.byColumns({ // sort.byColumn would work too
            sortingColumns: this.state.sortingColumns,
            selectedColumn
          })
        });
      }
    });

    const sortableHeader = sortHeader(sortable, () => this.state.sortingColumns);

    return [
      {
        //property: 'login',
        header: {
          label: t('main.lastname'),
          //formatters: [sortableHeader],
        
          props: {
            className: "col-md-4"
          }
        },
        cell:{
          formatters: [(value, { rowData }) => {
            return  `${rowData.prenom} ${rowData.nom}`
          }]
        },
        visible: true
      },

      /*{
        property: 'nom',
        header: {
          label: 'Nom',
          formatters: [sortableHeader],
          props: {
            className: "col-md-1"
          }
        },
        visible: true
      },
      {
        property: 'prenom',
        header: {
          label: 'Prénom',
          formatters: [sortableHeader],
          props: {
            className: "col-md-1"
          }
        },
        visible: true
      },*/

      {
        property: 'societe',
        header: {
          label: t('main.society'),
          formatters: [sortableHeader],
          props: {
            className: "col-md-1"
          }
        },
        visible: true
      },

      {
        //property: 'login',
        header: {
          label: t('login.login'),
          //formatters: [sortableHeader],
        
          props: {
            className: "col-md-4"
          }
        },
        cell:{
          formatters: [(value, { rowData }) => {
            var login = `${rowData.login}${rowData.super_user == 1 ? '-sup' : '-usr'}`
            return login

          }]
        },
        visible: true
      },

      {
        cell: {
          formatters: [(value, { rowData }) => {
            return <button disabled={self.props.loading} className="btn btn-default" type="button" onClick={() => {
              if (!self.props.loading) {
                self.props.associateUser(rowData);
              }
            }}>
              {t("main.add")}
					  </button>
          }]
        },
        width: 20,
        visible: true
      }

    ];
  }
  render() {
    const {
      rows, pagination, sortingColumns, searchColumn, query
    } = this.state;

    var columns = this.getColumns()

    const {t} = this.props

    const cols = columns.filter(column => column.visible);
    const paginated = compose(
      paginate(pagination),
      sort.sorter({ columns: cols, sortingColumns, sort: orderBy }),
      search.highlighter({ columns: cols, matches: search.matches, query }),
      search.multipleColumns({ columns: cols, query }),
      resolve.resolve({
        columns: cols,
        method: ({ rowData, column }) => resolve.byFunction('cell.resolve')({
          rowData: resolve.nested({ rowData, column }),
          column
        })
      })
    )(rows);

    var loading_text = this.props.loading ? <i className="fa fa-cog fa-spin fa-2x fa-fw"></i> : "";

    return (

      <Col xs={12}>

        <div style={{
          position: '',
          border: '1px solid lightgrey',
          padding: '12px 12px 30px 12px',
          background: ''
        }}
        >

          {/*<VisibilityToggles
          columns={columns}
          onToggleColumn={this.onToggleColumn}
        />*/}
          {rows.length > 0 &&
            <div>
              <div>
                <h4 style={{ display: 'inline' }}>
                  {t("userlist.associate_users")}
                 </h4>
                 {loading_text}
                 <br /><br />
                 
                <PrimaryControls
                  className="controls"
                  perPage={pagination.perPage}
                  column={searchColumn}
                  query={query}
                  columns={cols}
                  rows={rows}
                  onPerPage={this.onPerPage}
                  onColumnChange={this.onColumnChange}
                  onSearch={this.onSearch}
                  t={t}
                />

                <Table.Provider
                  className="table table-striped"
                  columns={cols}
                  style={{ overflowX: 'auto' }}
                >
                  <Table.Header>
                    {/*<SearchColumns query={query} columns={cols} onChange={this.onSearch} />*/}
                  </Table.Header>

                  <Table.Body onRow={this.onRow} rows={paginated.rows} rowKey="id" />

                  {/*<CustomFooter columns={cols} rows={paginated.rows} />*/}
                </Table.Provider>

              </div>

              <div>
                <div className="controls">
                  <Paginator
                    pagination={pagination}
                    pages={paginated.amount}
                    onSelect={this.onSelect}
                    prevText={t("pagination.previous")}
                    nextText={t("pagination.next")}
                  />
                </div>
              </div>

            </div>

          }

          {rows.length == 0 &&
            <span><b>{t('userlist.all_associated')}</b></span>
          }



        </div></Col>

    );
  }
  onRow(row, { rowIndex }) {
    return {
      onClick: () => this.onRowSelected(row)
    };
  }
  onRowSelected(row) {

  }
  onColumnChange(searchColumn) {
    this.setState({
      searchColumn
    });
  }
  onSearch(query) {
    this.setState({
      query
    });
  }
  onSelect(page) {
    const pages = Math.ceil(
      this.state.rows.length / this.state.pagination.perPage
    );

    this.setState({
      pagination: {
        ...this.state.pagination,
        page: Math.min(Math.max(page, 1), pages)
      }
    });
  }
  onPerPage(value) {
    this.setState({
      pagination: {
        ...this.state.pagination,
        perPage: parseInt(value, 10)
      }
    });
  }

  onToggleColumn(columnIndex) {
    const columns = cloneDeep(this.state.columns);
    const column = columns[columnIndex];
    column.visible = !column.visible;
    const query = cloneDeep(this.state.query);
    delete query[column.property];
    this.setState({ columns, query });
  }
}

const CustomFooter = ({ columns, rows }) => {
  return (
    <tfoot>
      <tr>
        {columns.map((column, i) =>
          <td key={`footer-${i}`}>{column.footer ? column.footer(rows) : null}</td>
        )}
      </tr>
    </tfoot>
  );
}

function sortHeader(sortable, getSortingColumns) {
  return (value, { columnIndex }) => {
    const sortingColumns = getSortingColumns() || [];

    return (
      <div style={{ display: 'inline' }}>
        <span className="value">{value}</span>
        {React.createElement(
          'span',
          sortable(
            value,
            {
              columnIndex
            },
            {
              style: { float: 'right' }
            }
          )
        )}
        {sortingColumns[columnIndex] &&
          <span className="sort-order" style={{ marginLeft: '0.5em', float: 'right' }}>
            {sortingColumns[columnIndex].position + 1}
          </span>
        }
      </div>
    );
  };
}